import { useEffect, useState } from 'react';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import Loader from 'components/loader/Loader';
import { useParams, useRouteMatch } from 'react-router-dom';
import { useStore } from 'stores/Store';
import useExercise from 'hooks/queries/useExercise';
import { ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE } from 'routes/RouteList';
import { Panel } from 'components/panel';
import ExerciseCard from 'containers/partials/cards/ExerciseCard';
import ExerciseNavigatorButtons from 'containers/pages/person/programs/components/ExerciseNavigatorButtons';

const ProgramExercise = () => {
  const { entityId, programId, exerciseId } = useParams();
  const active = useRouteMatch([ROUTE_USER_ENTITY_PROGRAMS_PROGRAM_EXERCISE]);

  const program = useStore(state => state.program);
  const { loading, error, fetchExercise } = useExercise(entityId);
  const [exercise, setExercise] = useState(null);

  useEffect(() => {
    const getExercise = async () => {
      const exercise = await fetchExercise(exerciseId);
      setExercise(exercise);
    };
    getExercise();
  }, [exerciseId]);

  if (loading || !exercise) return <Loader />;
  if (error) return <RetryPanel />;

  return (
    <Panel active={active?.isExact}>
      <ExerciseCard entityId={entityId} program={program} exercise={exercise} />

      <ExerciseNavigatorButtons
        entityId={entityId}
        programId={programId}
        exerciseId={exerciseId}
      />
    </Panel>
  );
};

export default ProgramExercise;
